import { render, staticRenderFns } from "./BillsTable.vue?vue&type=template&id=d0ef0acc"
import script from "./BillsTable.vue?vue&type=script&lang=js"
export * from "./BillsTable.vue?vue&type=script&lang=js"
import style0 from "./BillsTable.vue?vue&type=style&index=0&id=d0ef0acc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports